module.exports = __webpack_public_path__ + "assets/img/ic-wel-bag.a6fb92b1.png";